import { getEnvVar } from './getEnvVar'

export function isProductionEnv() {
  return getEnvVar('ENV') === 'production'
}
